// Maps common color/material names from Shopify variant options to hex swatches.
// Falls back to a neutral cream if no match.
const COLOR_MAP: Record<string, string> = {
  black: "#0d0d0d",
  white: "#FDFAF3",
  cream: "#F5EFE2",
  bone: "#EDE6D6",
  natural: "#E0D4B8",
  tan: "#C6A971",
  khaki: "#B8A07A",
  sand: "#D4BC8A",
  brown: "#412019",
  chocolate: "#3a1f12",
  coffee: "#4a2c1c",
  saddle: "#8B6F47",
  caramel: "#A0703F",
  mocha: "#6F4E37",
  rust: "#9A3B17",
  blaze: "#FA5021",
  orange: "#FA5021",
  red: "#A23320",
  burgundy: "#5A1F1A",
  maroon: "#5A1F1A",
  olive: "#5A5A2E",
  army: "#4B5320",
  green: "#2E5A3D",
  forest: "#1a3c2a",
  hunter: "#1F3D2A",
  navy: "#0c2340",
  blue: "#1a4a6e",
  denim: "#3B5A78",
  charcoal: "#36352F",
  grey: "#6E6A60",
  gray: "#6E6A60",
  pink: "#D9A6A0",
  yellow: "#E8B84A",
  gold: "#C9A84C",
};

export function colorToHex(value: string): string {
  if (!value) return "#C6A971";
  const key = value.toLowerCase().trim();
  // direct hit
  if (COLOR_MAP[key]) return COLOR_MAP[key];
  // partial hit (e.g. "Dark Brown", "Heritage Tan")
  for (const k of Object.keys(COLOR_MAP)) {
    if (key.includes(k)) return COLOR_MAP[k];
  }
  return "#C6A971"; // saddle tan default
}
